module.exports = __webpack_public_path__ + "img/сard_gray.127f6487.jpg";